import { addToChainAfter, ApiHandlerDiscreteParameter, HasOnError } from "@insite/client-framework/HandlerCreator";
import { Cart, CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { chain, SendTracking } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { addPaymentInfo, purchase } from "@WhiteCap/Common/Utillities/CustomTracking";
import { getTotalPrice, PriceItem } from "@WhiteCap/Common/Utillities/utils";

interface PlaceOrderParameter {
    paymentMethod: string;
    poNumber: string;
    vatNumber?: string;
    saveCard: boolean;
    cardHolderName: string;
    cardNumber: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
    securityCode: string;
    useBillingAddress: boolean;
    address1: string;
    countryId: string;
    stateId: string;
    city: string;
    postalCode: string;
    onSuccess?: (cartId: string) => void;
    payPalToken?: string;
    payPalPayerId?: string;
    isPending?: boolean;
    isAdyenDropIn?: boolean;
    adyenPspReference?: string;
    accountHolderName?: string;
    accountNumber?: string;
    routingNumber?: string;
    payerId: string;
    maskedCardNumber: string;
}

type HandlerType = ApiHandlerDiscreteParameter<
    PlaceOrderParameter & HasOnError,
    UpdateCartApiParameter,
    CartResult,
    {
        cartToUpdate: Cart;
    }
>;

export const TriggerAddPaymentInfoEvent: HandlerType = props => {
    const itemData = [];
    const priceQty: PriceItem[] = [];
    if (props.cartToUpdate.cartLines && props.cartToUpdate.cartLines.length) {
        for (let i = 0; i < props.cartToUpdate.cartLines.length; i++) {
            itemData.push({
                item_id: props.cartToUpdate.cartLines[i].erpNumber,
                item_name: props.cartToUpdate.cartLines[i].shortDescription,
                item_brand: props.cartToUpdate.cartLines[i].brand?.name
                    ? props.cartToUpdate.cartLines[i].brand?.name
                    : "",
                price: props.cartToUpdate.cartLines[i].pricing?.actualPrice,
                quantity: props.cartToUpdate.cartLines[i].qtyOrdered,
                item_category: "",
                item_category2: "",
                item_category3: "",
                item_variant: "Standard",
                coupon:""
            });

            priceQty.push({
                price: props.cartToUpdate.cartLines[i].pricing?.actualPrice ?? 0,
                quantity: props.cartToUpdate.cartLines[i].qtyOrdered ?? 1,
            });
        }
    }
    const data = {
        event: "add_payment_info",
        ecommerce: {
            currency: "USD",
            value: getTotalPrice(priceQty),
            payment_type: props.apiParameter.cart.paymentMethod?.description,
            items: itemData,
        },
    };
    addPaymentInfo(data);
};

addToChainAfter(chain, SendTracking, TriggerAddPaymentInfoEvent);
